const UNIVERSITIES = [
  "🇬🇧 King's College London",
  '🇺🇸 Penn State University',
  '🇬🇧 University of Leeds',
  '🇬🇧 University of Birmingham',
  '🇬🇧 University of Southampton',
  '🇺🇸 Washington University',
  '🇩🇪 TU Berlin',
  '🇸🇪 Uppsala University',
  '🇳🇱 Leiden University',
];

export function initUniversityMarquee(container) {
  if (!container) return;
  const track = document.createElement('div');
  track.className = 'landing-marquee-track';
  const make = (txt) => {
    const s = document.createElement('span');
    s.textContent = txt;
    s.className = 'landing-marquee-item';
    return s;
  };
  [...UNIVERSITIES, ...UNIVERSITIES].forEach((u) => track.appendChild(make(u)));
  container.appendChild(track);
}

export function initFadeUp() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('visible'), (i % 4) * 70);
          observer.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  document.querySelectorAll('.landing-fade-up').forEach((el) => observer.observe(el));
  return () => observer.disconnect();
}

export function initNavbarTheme(navbar, hero) {
  if (!navbar) return () => {};

  const navHeight = navbar.offsetHeight || 68;

  const apply = (onLight) => {
    navbar.classList.toggle('landing-nav--on-light', onLight);
  };

  const update = () => {
    if (!hero) {
      apply(window.scrollY > navHeight);
      return;
    }
    apply(hero.getBoundingClientRect().bottom <= navHeight);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  return () => {
    window.removeEventListener('scroll', update);
    window.removeEventListener('resize', update);
  };
}

export function initHeroTilt(card, wrap) {
  if (!card || !wrap) return () => {};
  let ticking = false;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const update = () => {
    const rect = wrap.getBoundingClientRect();
    const vh = window.innerHeight;
    const start = vh * 0.95;
    const end = vh * 0.25;
    const p = clamp((start - rect.top) / (start - end), 0, 1);
    const rot = 34 - 34 * p;
    const scale = 1.02 - 0.02 * p;
    card.style.transform = `rotateX(${rot.toFixed(2)}deg) scale(${scale.toFixed(3)})`;
    ticking = false;
  };
  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
  return () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
  };
}

export function initSparkles(canvas, hero) {
  if (!canvas || !hero) return () => {};
  const ctx = canvas.getContext('2d');
  let w;
  let h;
  let dpr;
  let particles = [];
  let raf;
  const COUNT = 90;
  const rand = (a, b) => a + Math.random() * (b - a);

  const resize = () => {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = hero.offsetWidth;
    h = hero.offsetHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = `${w}px`;
    canvas.style.height = `${h}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };

  const makeParticle = () => ({
    x: rand(0, w),
    y: rand(0, h),
    r: rand(0.4, 1.8),
    baseA: rand(0.15, 0.9),
    a: rand(0, 1),
    tw: rand(0.005, 0.02),
    dir: Math.random() < 0.5 ? 1 : -1,
    vy: rand(-0.12, -0.45),
    vx: rand(-0.12, 0.12),
    red: Math.random() < 0.18,
  });

  const init = () => {
    resize();
    particles = Array.from({ length: COUNT }, makeParticle);
  };

  const draw = () => {
    ctx.clearRect(0, 0, w, h);
    for (const p of particles) {
      p.a += p.tw * p.dir;
      if (p.a >= p.baseA) {
        p.a = p.baseA;
        p.dir = -1;
      }
      if (p.a <= 0.04) {
        p.a = 0.04;
        p.dir = 1;
      }
      p.y += p.vy;
      p.x += p.vx;
      if (p.y < -4) {
        p.y = h + 4;
        p.x = rand(0, w);
      }
      if (p.x < -4) p.x = w + 4;
      if (p.x > w + 4) p.x = -4;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = p.red ? `rgba(255,90,105,${p.a})` : `rgba(255,255,255,${p.a})`;
      if (p.r > 1.2) {
        ctx.shadowBlur = 6;
        ctx.shadowColor = p.red ? 'rgba(232,25,44,0.6)' : 'rgba(255,255,255,0.6)';
      } else {
        ctx.shadowBlur = 0;
      }
      ctx.fill();
    }
    ctx.shadowBlur = 0;
    raf = requestAnimationFrame(draw);
  };

  init();
  draw();

  let rt;
  const onResize = () => {
    clearTimeout(rt);
    rt = setTimeout(init, 200);
  };
  window.addEventListener('resize', onResize);

  const io = new IntersectionObserver(
    (e) => {
      if (e[0].isIntersecting) {
        if (!raf) draw();
      } else {
        cancelAnimationFrame(raf);
        raf = null;
      }
    },
    { threshold: 0 }
  );
  io.observe(hero);

  return () => {
    cancelAnimationFrame(raf);
    window.removeEventListener('resize', onResize);
    clearTimeout(rt);
    io.disconnect();
  };
}
